import { Form, Input, Select, Row, Col, message, Modal, DatePicker } from 'antd';
import { useEffect, useState } from 'react';
import { SDrawerOrModal } from 'shj-components';
import { addActivity, updateActivity } from '@/services/product';
import styles from '../index.module.less';
import dayjs from 'dayjs';

const { Option } = Select;

const AddOrEditForm = (props: any) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const { id, show, setVisible, editData, bizType, activityTypeList, companyList = [], productList = [], onClose } = props;

  useEffect(() => {
    // 处理时间格式
    const formData = {
      ...editData,
      startDate: editData?.startDate ? dayjs(editData.startDate._i) : undefined,
      endDate: editData?.endDate ? dayjs(editData.endDate._i) : undefined
    };
    form.setFieldsValue(formData);
  }, [editData]);

  const onFinish = async (values) => {
    try {
      const data: any = {};
      if (!values.name) {
        message.error('请输入活动名称');
        return false;
      }
      data.name = values.name;
      if (!values.startDate) {
        message.error('请选择活动起止时间！');
        return false;
      }
      if (!values.endDate) {
        message.error('请选择活动起止时间！');
        return false;
      }
      data.startDate = values.startDate.format('YYYY-MM-DD');
      data.endDate = values.endDate.format('YYYY-MM-DD');
      if (!values.type) {
        message.error('请选择活动类型');
        return false;
      }
      data.type = values.type;
      if (!values.description) {
        message.error('请输入活动描述');
        return false;
      }
  
      if (!values.shopIds?.length) {
        message.error('请选择适用门店');
        return false;
      }
  
      if (!values.productIds?.length) {
        return message.error('请选择适用产品');
      }
  
      data.description = values.description;
      data.shopIds = values?.shopIds;
      data.productIds = values?.productIds;
  
      if (!id) {
        setLoading(true)
        const res: any = await addActivity(data);
        setLoading(false)
        if (res.id) {
          message.success('新增成功');
          setVisible(false);
        }
      } else {
        setLoading(true)
        const res: any = await updateActivity({ ...data, id });
        setLoading(false)
        if (res.id) {
          message.success('编辑成功');
          setVisible(false);
        }
      }
    } catch (err) {
      setLoading(false)
      console.log(err)
    }
  };

  const closeModal = () => {
    onClose();
  };
  const onSubmit = () => {
    form.submit();
  };
  return (
    <SDrawerOrModal
      mode='drawer'
      title={id ? '编辑活动' : '新增活动'}
      open={show}
      onOk={onSubmit}
      onCancel={closeModal}
      loading={loading}
      width="500px"
      okText="保存"
      cancelText="取消"
    >
      <div className={styles.case_content}>
        <Form preserve={false} className={styles.form_content} name="validate_other" onFinish={onFinish} form={form} layout="vertical">
          <Row>
            <Col span={24}>
              <Form.Item name="name" label="活动名称" className={`${styles.case_item} ${styles.case_label_required}`}>
                <Input placeholder="请输入" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                name="startDate"
                label="开始日期"
                className={`${styles.case_item} ${styles.case_label_required}`}
              >
                <DatePicker placeholder={'开始日期'} format="YYYY-MM-DD" style={{ display: 'block' }} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                name="endDate"
                label="结束日期"
                className={`${styles.case_item} ${styles.case_label_required}`}
              >
                <DatePicker placeholder={'结束日期'} format="YYYY-MM-DD" style={{ display: 'block' }} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item name="type" label="活动类型" className={`${styles.case_item} ${styles.case_label_required}`}>
                <Select disabled={id} placeholder="请选择" className={styles.case_item_select}>
                  {activityTypeList.map((item, index) => (
                    <Option key={item.value} value={item.value}>
                      {item.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={2}></Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                name="shopIds"
                label="适用门店"
                className={`${styles.case_item} ${styles.case_label_required}`}
              >
                <Select optionFilterProp="companyName" placeholder="请选择" mode="multiple" className={styles.case_item_select} options={companyList} fieldNames={{ label: 'companyName', value: 'id'}}>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                name="productIds"
                label="适用产品"
                className={`${styles.case_item} ${styles.case_label_required}`}
              >
                <Select optionFilterProp="label" placeholder="请选择" mode="multiple" className={styles.case_item_select} options={productList}>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                name="description"
                className={`${styles.case_item} ${styles.case_label_required}`}
                label="活动描述"
              >
                <Input.TextArea autoSize={{ minRows: 4, maxRows: 8 }} placeholder="请输入" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </SDrawerOrModal>
  );
};

export default AddOrEditForm;
